import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { updateData } from '../../../services';
import ConfirmDialog from '../../helpers/ConfirmDialog';
import { canUserArchiveProject } from '../../../utils/projects';

export const DeleteProjectForm = ({ project }) => {
    const { token, base_url, setProjects, user, invoices } = useAppContext();
    const navigate = useNavigate();
    const canArchive = canUserArchiveProject(project, { user, invoices });

    if (!canArchive) {
        return null;
    }

    return (
        <ConfirmDialog
            trigger={
                <button
                    className="btn btn-action btn-danger btn-offset-left"
                    title="Delete Project"
                >
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            }
            title="Archive Project"
            message="Are you sure you want to archive this project?"
            entityLabel={`Project: ${project?.name}`}
            detail="This action will archive the project and remove it from your active projects list."
            confirmLabel="Archive Project"
            submittingLabel="Archiving..."
            successMessage="Project archived successfully!"
            errorMessages={{
                notFound: 'Project not found',
                client: 'Invalid project data. Please check your input.',
                default: 'Failed to archive project. Please try again.',
            }}
            onConfirm={async () => {
                const updated_project = await updateData(
                    token,
                    `${base_url}/apis/projects/${project.id}`,
                    { is_archived: true }
                );

                if (!updated_project.project) return false;

                setProjects((prevProjects) =>
                    prevProjects.map((p) =>
                        p.id === project.id ? updated_project.project : p
                    )
                );
                navigate('/');
            }}
        />
    );
};
